export enum ValuationDataValues {
  FNMA_1004_FHLMC_70 = "Fannie Mae 1004/Freddie Mac 70",
  FNMA_1025_FHLMC_72 = "Fannie Mae 1025/Freddie Mac 72",
  FNMA_1073_FHLMC_465 = "Fannie Mae 1073/Freddie Mac 465",
  FNMA_1004C_FHLMC_70B = "Fannie Mae 1004C/Freddie Mac 70B",
  FNMA_1004D_FHLMC_442 = "Fannie Mae Form 1004D/Freddie Mac 442",
  FNMA_2055_FHLMC_2055 = "Fannie Mae 2055/Freddie Mac 2055",
  FNMA_1075_FHLMC_466 = "Fannie Mae 1075/Freddie Mac 466",
  DESK_REVIEW = "Desk Review",
  HYBRID = "Hybrid",
  BPO = "BPO",
  MAI = "MAI",
}
